import {
  formatDenominatedNumber,
  getFarmContractName
} from 'helpers/mvx/formatters';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import BigNumber from 'bignumber.js';
import { SnapshotDataComparisonChart } from 'components/SnapshotComparisonChart';

export const SnapshotComparisonChart = () => {
  const farmData = useSelector((state: RootState) => state.rawVesta.config);

  return farmData.data === null ? null : (
    <div className='accordion-item' style={{ borderRadius: '0.625rem' }}>
      <h2 className='accordion-header' id='headingThree'>
        <button
          className='accordion-button text-center'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseThree'
          aria-expanded='true'
          aria-controls='collapseThree'
        >
          Show Snapshot Comparison
        </button>
      </h2>
      <div
        id='collapseThree'
        className='accordion-collapse collapse'
        aria-labelledby='headingThree'
        data-bs-parent='#accordionExampleThree'
      >
        <div className='accordion-body'>
          <div className='container-fluid w-100'>
            <div className='row'>
              <div className='col-12' style={{ minHeight: '50vh' }}>
                <SnapshotDataComparisonChart
                  snapshotData={farmData.data.farmAddresses.map((address) => {
                    return {
                      address,
                      name: getFarmContractName(address),
                      snapshotData: farmData.data?.snapshots[address] ?? []
                    };
                  })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
